import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": true
}
const browserTab = createSlice({
    name:'browserTab',
    initialState,
    reducers:{
        addBrowserTab: (_state, payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default browserTab.reducer
export const addBrowserTab = browserTab.actions.addBrowserTab